export default null;

export const ESTIMATE_COMPANY_LIST = [
	'주식회사 브로',
	'카픽',
	'헤머모터스',
	'마자카',
	'보람자동차',
	'(주)유니앤모터스',
	'더 새로운',
	'무결점 카모터스',
	'오토스펙',
	'최강모터스',
	'(주)한경자동차',
	'차여사',
	'동그라미 모터스',
	'주식회사 열린자동차',
	'케이모터스',
	'시그니처 모터스',
	'주식회사 엘케이모터스',
	'주식회사 왕카',
	'주식회사 부싼카',
	'유니크 모터스',
	'에이치에스',
	'에스티모터스',
	'창원중고차 태성모터스',
	'엠에이씨글로벌',
	'주식회사 픽플러스 ARC',
	'보배모터스',
	'오토플러스(주) 부산지점',
	'(주)우진오토모빌',
	'카카오토',
	'바른자동차',
	'주식회사 오토베이스',
	'주식회사 오토빌리지',
	'타이거모터스',
	'주식회사 케이비에이오토',
	'제일모터스',
	'케이엘마스터',
	'웰컴바이어',
	'포봉스자동차',
	'대신모터스',
	'제이원모터스',
	'지에스모터스',
	'에이스모터스',
	'주식회사 에스앤케이모터스',
	'코오롱오토오션 주식회사 용인',
	'디에스(DS)대산',
	'주식회사 씨피오토모티브',
	'주식회사 다일모터스',
	'코오롱오토옥션 주식회사 안성지점',
	'대한모터스',
	'바른모터스',
	'모든자동차',
	'주식회사 코렉트',
	'K2모터스',
	'우진모터스',
	'허니비모터스',
	'한마음모터스',
	'뉴합동모터스',
	'NEW 익산모터스',
	'카몬',
	'허니카모터스',
	'혁신모터스',
	'유한회사 마이카',
	'중고차파크',
	'유한회사 우리모터스',
	'행운모터스',
	'GS카넷',
	'(유)대유모터스',
	'카마트',
	'태양모터스',
	'MK상사',
	'미래모터스',
	'유한회사 미라클',
	'(주)진모터스',
	'탑모터스',
	'에스케이모터스',
	'제이트럭매매상사',
	'(유)원모터스',
	'동아자동차',
	'하림모터스',
	'자동차마을',
	'민모터스',
	'대덕자동차매매상사',
	'서울모터스 매매상사',
	'현모터스',
	'(유)연모터스',
	'(주)오토핸즈',
	'드림모터스',
	'차사랑 모터스 매매상사',
	'당근 수출 무역',
	'제이비차프로',
	'주식회사카웨이코리아',
	'우리오토',
	'한빛모터스',
	'더존오토샵',
	'베스트모터스',
	'한스오토랜드',
	'한성월드',
	'짱카',
	'조은모터스',
	'슈퍼카모터스',
	'스마일모터스',
	'한국자동차매매상사',
	'카올스상사',
	'바른손모터스',
	'유한회사 오토월드',
	'백악관모터스',
	'롯데자동차매매상사',
	'은혜자동차매매상사',
	'에코모터스',
	'하나모터스',
	'현모터스',
	'유한회사 로고',
	'대성모터스',
	'중앙모터스',
	'선모터스',
	'강남모터스',
	'뉴스타',
	'스마일모터스',
	'오토갤러리',
	'효자상사',
	'전라모터스',
	'(주) 센텀',
	'유한회사 예림모터스',
	'(주) 대오모터스',
	'주식회사 뉴오케이모터스',
	'(유)매월자동차매매상사',
	'더카 주식회사',
	'주식회사 로또자동차',
	'(주)선경자동차매매상사',
	'주식회사 세계모터스',
	'주식회사 스마일모터스',
	'스타오토모빌(주)',
	'주식회사 씨제이모터스',
	'주식회사 오뚜기모터스',
	'주식회사 우수광주중고차',
	'주식회사 우일모터스',
	'(주)가온모터스',
	'주식회사 국민자동차',
	'(주)디에이치모터스',
	'모던모터스(주)',
	'(유)쌍둥이모터스',
	'주식회사 엠블오토모빌',
	'유한회사 정도모터스',
	'(주)우리모터스',
	'(주)진원모터스',
	'주식회사 두드림모터스',
	'주식회사 케이자동차',
	'주식회사 차차모터스',
	'주식회사 차사랑모터스',
	'주식회사 뉴광주모터스',
	'주식회사 드림카마켓',
	'(유)하나자동차매매상사',
	'유한회사 홍카모터스',
	'기아오토스 주식회사',
	'알이랑모터스 주식회사',
	'(주)태양모터스',
	'주식회사 신한길모터스',
	'주식회사 워너비모터스',
	'(주)고바우',
	'유한회사 춘자네중고차',
	'해태자동차',
	'(주)광주중고차153 모터스',
	'유한회사 대성모터스',
	'주식회사 삼덕모터스',
	'주식회사 케이원모터스',
	'주식회사 하늘모터스',
	'유한회사 대영모터스',
	'(주)더바른모터스',
	'에스원모터스',
	'주식회사 이지모터스',
	'케이투모터스',
	'(주)조이갤러리',
	'(주)엠모터스',
	'주식회사 대양모터스',
	'(주)으뜸모터스',
	'(주)오토프라자',
	'(주)에이프로',
	'마하 주식회사',
	'(주)삼성모터스',
	'주식회사 포인트모터스',
	'(주)거성모터스',
	'진흥자동차',
	'유한회사 현철모터스',
	'삼덕상사',
	'위너모터스(주)',
	'케이카광주수완지점',
	'주식회사 이음오토',
	'(주)가람모터스',
	'(주)백두모터스',
	'(주)오빠상사',
	'주식회사 행복모터스',
	'주식회사 브이티오토',
	'믿음모터스',
	'유)고바우상사',
	'송원모터스',
	'신한자동차',
	'이슬모터스',
	'주식회사 파랑새모터스',
	'코오롱모터스(주) BPS광주지점',
	'위드카갤러리',
	'(주)이글모터스',
	'케이에스상사',
	'한영모터스',
	'디에스모터스',
	'골드모터스',
	'자동차이야기',
	'시그니처모터스',
	'도은모터스',
	'전라도모터스',
	'오토랜드',
	'효모터스',
	'유진모터스',
	'오토일일사',
	'우주자동차매매상사',
	'엠케이모터스',
	'조은모터스',
	'황금자동차매매상사',
	'고고모터스',
	'홍길동자동차매매상사',
	'(주)앤탑',
	'(주) 금강자동차',
	'주식회사 드림카마켓2',
	'유한회사 하남모터스',
	'삼일모터스',
	'모든카',
	'(유)우진자동차',
	'아이비원모터스',
	'문엔정',
	'피앤제이모터스',
	'(주) 한라자동차',
	'(주)오토핸즈 오토인사이드자동차전시장 광주직영점',
	'한백자동차매매상사',
	'한국모터스',
	'주식회사 원모터스',
	'더원모터스',
	'주식회사 신성오토모빌',
	'무지개모터스',
	'다산모터스',
	'(주)국가대표',
	'신암자동차(주)',
	'주식회사 뉴자동차마을',
	'오토플러스(주)광주지점',
	'(주)21세기모터스',
	'덕산자동차매매상사',
	'오아시스모터스',
	'다이렉트카',
	'바로모터스',
	'주식회사 광주풍암중고차상사',
	'(주)펀카',
	'마당쇠중고차',
	'유달중고차 매매상사',
	'으라차차 모터스',
	'형제모터스',
	'명품모터스',
	'선진 모터스',
	'세운 모터스',
	'현대매매상사',
	'스카이 모터스',
	'제이케이모터스(JK모터스)',
	'주식회사 지티컴퍼니',
	'S카모터스',
	'정든자동차',
	'유진모터스',
	'드림카',
	'가온모터스',
	'루이모터스',
	'올카옥션 매매상사',
	'바른모터스',
	'주식회사 대진모터스',
	'스타모터스',
	'스타상사',
	'JC모터스',
	'장수모터스',
	'VIP모터스',
	'대한모터스',
	'희망모터스',
	'차고남(차를 고치는 남자들)',
	'(주)케이비모터스',
	'봄모터스',
	'골드모터스',
	'비카(Bee CAR)',
	'두산모터스',
	'행복모터스',
	'카팡모터스',
	'주식회사 바이오토',
	'강호모터스',
	'(주)카베이',
	'카플릭스(CARFLIX)',
	'더드림 모터스',
	'신박한자동차',
	'꿀벌카',
	'주식회사 코리아트레이딩',
	'우정모터스',
	'인하모터스',
	'(주)일등중고차',
	'주식회사 일공공일케이카',
	'(주)에이케이모터스',
	'(주)우리들모터스',
	'한결모터스',
	'친구중고차',
	's&k모터스자동차매매상사',
	'백두무역',
	'주식회사 에이블오토',
	'정우모터스 주식회사',
	'(주)카엔카',
	'주식회사 투게더카',
	'폴리텍트레이드',
	'디디 트레이드',
	'아인모터스',
	'부싼카 인천점',
	'(주)에이더블유컴퍼니',
	'카카오토',
	'피케이트레이딩',
	'카멘토',
	'두드림자동차',
	'(주)효성모터스',
	'유림모터스',
	'당근자동차상사',
	'주식회사 지온컴퍼니',
	'카슐랭 모터스',
	'(주)광현',
	'(주)오토라인모터스',
	'카픽',
	'주식회사 프라임스타',
	'힐링모터스',
	'주식회사 썸카',
	'주식회사 플랜오토',
	'주식회사 피스모터스',
	'블루오토',
	'코오롱모터스(주) BPS서울지점',
	'모던모터스',
	'(주)정직한놈들',
	'대건',
	'이지카(Ez Car)',
	'스마일자동차',
	'(주)제이제이오토컴퍼니',
	'(주)모터프라자',
	'로또모터스',
	'에이지모터스',
	'김모터스글로벌 주식회사',
	'케이(K)오토',
	'달인모터스',
	'케이카 주식회사 광명지점',
	'황소모터스',
	'금빛모터스',
	'(주)베스트',
	'우리주원모터스',
	'태영모터스',
	'오토플러스(주) 인천지점',
	'주식회사 오광자동차',
	'트라이모터스',
	'주식회사 선모터스',
	'오토웨이브',
	'케이원 모터스',
	'케이카 주식회사 아산지점',
	'(주)에스에이치모터스',
	'신원자동차매매상사',
	'주식회사 에이치엔카',
	'주식회사 카온네트웍스',
	'아시아모터스',
	'시아모터스',
	'주식회사 부시맨',
	'주식회사 제이파크',
	'우성모터스',
	'주식회사 KB인증중고차',
	'(주)에이엠지모터스',
	'잘팔카',
	'코리아모터스자동차매매상사',
	'주식회사 홍차',
	'아이엔지(ING)',
	'JP모터스자동차매매상사',
	'주식회사 써니카',
	'주식회사 용일상사',
	'굿카대표 모터스',
	'(주)유일모터스자동차매매',
	'카프라자자동차매매상사',
	'(주)탁월한선택',
	'(주)시우자동차3',
	'카담파트너스',
	'케이카 주식회사 경인지점',
	'패밀리카',
	'왓차 중고차',
	'범스카',
	'주식회사애니카모터스',
	'착한중고차',
	'주식회사 굿프렌즈파트너스',
	'신신상사 주식회사',
	'신대진자동차',
	'차본주의',
	'자동차1번지 자동차매매상사',
	'조이카모터스자동차매매상사',
	'와이티모터스 주식회사',
	'비비모터스매매상사',
	'(주)타워모터스',
	'에이치투모터스',
	'뉴AK모터스',
	'좋은차와사람들자동차매매상사',
	'(주)강인모터스',
	'올바른자동차',
	'참좋은모터스',
	'케이모터스',
	'지티 오토',
	'자동차연구소',
	'디에이치모터스',
	'JP모터스자동차매매상사',
	'주식회사 에스와이오토',
	'(주)경원모터스',
	'주식회사 누리모터스',
	'주식회사 하이카모터스',
	'주식회사 케이엠모터스',
	'파크모터스',
	'민모터스',
	'카누리모터스',
	'유원모터스',
	'의리차차차',
	'스마트상사',
	'카카오토',
	'킹덤모터스',
	'엘앤송도오토모티브',
	'이레카',
	'(주)국민상사',
	'원스탑모터스 주식회사',
	'에쿠스자동차',
	'조은자동차매매상사',
	'주식회사 드림오토상사',
	'유성모터스',
	'춘호무역',
	'코카스모터스자동차매매상사',
	'(주)트루카',
	'진솔모터스',
	'엘림코리아',
	'스카이모터스자동차매매상사',
	'필승모터스',
	'세이프웨이오토',
	'에프오모터스',
	'민 Min TRAPING',
	'오토피아자동차매매상사',
	'주식회사 카스갤러리',
	'주식회사 시우자동차',
	'바다무역',
	'(주)엔젤모터스',
	'주식회사 진모터스',
	'차들',
	'주식회사 시우자동차2',
	'다올모터스',
	'미래모터스자동차매매상사',
	'바른모터스',
	'주식회사 대한모터스',
	'허니무역',
	'대연상사',
	'지티오토컴퍼니',
	'주식회사 혜안모터스',
	'주식회사 모터스퀘어',
	'주식회사 지엠컴퍼니',
	'플러스 오토',
	'오토허브 엠파크지점',
	'오토그린모터스',
	'유케이모터스',
	'주식회사 인생내차',
	'우민모터스',
	'한솔모터스',
	'케이카 주식회사 인천지점',
	'레드모터스',
	'주식회사 준모터스',
	'와이비모터스',
	'모터바겐',
	'주식회사 케이비모터스',
	'(주)탑모터스',
	'주식회사 도담',
	'재운모터스',
	'차만사',
	'에스모터스',
	'오토팰리스',
	'청춘카',
	'주식회사 카체인지',
	'정일모터스',
	'주식회사 건우모터스',
	'(주)케이탑인터내셔널',
	'제이디 모터스',
	'솔카',
	'오토위더스',
	'성민&대동모터스',
	'형제자동차매매상사',
	'엠엔제이오토모빌',
	'미르모터스',
	'우진모터스',
	'타요모터스',
	'대진자동차',
	'오케이모터스',
	'(주)마이카',
	'카스토리',
	'주식회사 윈드랩',
	'원스타',
	'주식회사 엠코어그룹',
	'(주)마루자동차',
	'코오롱모터스(주)BPS부천지점',
	'원투카모터스',
	'아슬란모터스매매상사',
	'드림카모터스',
	'성원자동차매매상사',
	'한우카부산',
	'케이씨씨오토리움(주) AAP김포지점',
	'신호등모터스',
	'그린모터스',
	'지디카 GD CAR',
	'더월드모터스',
	'비모터스',
	'행복모터스',
	'에이치오토모티브',
	'더블유오토',
	'최강모터스',
	'제로모터스',
	'주식회사 부산대박중고차',
	'주식회사 모터스링크',
	'오산트럭매매상사',
	'카마스터',
	'주식회사 전국자동차',
	'글로벌모터스',
	'굿모닝모터스',
	'우진종합자동차상사',
	'인증중고차',
	'(주)엔터카',
	'소망모터스',
	'우리모터스',
	'더원모터스',
	'한모터스',
	'라인모터스',
	'금강자동차상사',
	'카스토리',
	'카스토리',
	'바바모터스',
	'신사모터스',
	'(주)히든모터스',
	'마이카',
	'더올림모터스',
	'연합모터스',
	'주식회사 브로엠',
	'럭키상사',
	'지에스카넷',
	'청주중고차닷컴매매상사',
	'주식회사 지오모터스',
	'굿럭무역',
	'열정모터스',
	'(주)아우토나인',
	'(주) 전진',
	'코오롱모빌리티그룹(주) 702Prime 부산지점',
	'주식회사 제이앤제이모터스',
	'주식회사 더원오토',
	'주식회사 롱탄',
	'주식회사 미소모터스',
	'조은모터스 주식회사',
	'차왕모터스',
	'신서울모터스(주)',
	'승리모터스(주)',
	'주식회사 노빌리티 경기지점',
	'주식회사 창인자동차',
	'라희모터스 동부산점',
	'드림모터스 주식회사',
	'주식회사 위메카',
	'차차모터스',
	'(주)엠모터스',
	'주식회사 제이케이오토모빌',
	'조이모터스',
	'케이카 주식회사 안산지점',
	'올바른모터스',
	'케이카 주식회사 안양지점',
	'(주)바바리안모터스',
	'차차',
	'주배모터스',
	'해피카',
	'신화모터스',
	'오토브릿지코리아',
	'한성자동차매매상사',
	'오토모빌',
	'신림 자동차 매매상사',
	'활로상사',
	'마스터카',
	'홈카',
	'케이 모빌리티',
	'대상모터스',
	'오토플러스(주) 리본카 서울지점',
	'명성자동차매매상사',
	'아람모터스',
	'셀카',
	'다올 오토',
	'카온',
	'스타오토모티브',
	'바른모터스',
	'노블모터스',
	'제이제이모터스',
	'차란차 주식회사 수원오토월드 지점',
	'승리자동차',
	'(주)넘버원모터스',
	'제니스오토',
	'와이엠모터스',
	'엠제이(MJ)모터스',
	'으랏차차',
	'포항자동차매매상사',
	'에스오토',
	'울산중고차',
	'주식회사 하이오토',
	'2N모터스',
	'수원중고차',
	'케이씨씨오토(주) 양재',
	'안심상사',
	'장성대형화물자동차매매상사',
	'(주)칠칠카모터스',
	'정성모터스',
	'아이앤지모터스',
	'굿피플 트레이딩 (GP TRADING)',
	'대한자동차매매상사',
	'에이비에이 트레이딩&서비스',
	'한진상사',
	'고려자동차매매상사',
	'(주)에어라인오토',
	'주식회사 킹카',
	'카-써클',
	'연우무역',
	'오토플러스(주) 리본카 김포지점',
	'대양모터스',
	'병영모터스',
	'명문자동차',
	'프렌즈모터스',
	'찰떡모터스',
	'(주) 현대중고차 매매상사',
	'동대구자동차매매상사티에스씨(주)',
	'에스모터스',
	'경남부산트럭 매매상사',
	'주식회사 유로오토',
	'봉모터스',
	'새차처럼 모터스',
	'(주)유카 전주지점',
	'케이티오토컴퍼니',
	'믿음모터스',
	'대연모터스',
	'베스트카',
	'헤이모터스',
	'에스에스케이',
	'원컴퍼니',
	'최강모터스',
	'준수모터스',
	'대공중고자동차상사',
	'코오롱모빌리티그룹(주)702 Prime대구지점',
	'철인모터스',
	'(주) 리버',
	'M모터스',
	'건모터스',
	'보배드림 자동차테마파크',
	'스타자동차매매상사',
	'티원모터스 (T-1 MOTORS)',
	'통일모터스',
	'현대모터스',
	'삼광모터스',
	'서수원모터스',
	'무한모터스',
	'대도모터스',
	'에스케이모터스',
	'젠틀카',
	'원큐모빌리티',
	'원 모터스',
	'남진특장',
	'(주)대성모터스',
	'제이모터스',
	'한국자동차선물거래소',
	'영남자동차상사',
	'하늘오토',
	'중앙자동차매매상사',
	'뉴 한길모터스',
	'에스카',
	'한결자동차',
	'뉴일등모터스',
	'강남모터스',
	'차순이모터스',
	'성서자동차상사',
	'토탈자동차매매상사',
	'하나오토',
	'조선의 안녕첫차',
	'차사랑',
	'핀카',
	'스마일 중고차',
	'한빛인터내셔날',
	'주식회사 카핑',
	'육복',
	'카픽',
	'조조오토',
	'오토플러스(주) 천안지점',
	'중앙상사',
	'코오롱모터스(주)BPS 양산지점',
	'탑모터스',
	'한솔트럭',
	'주식회사 마이카',
	'주식회사 오토메이트',
	'광원자동차매매상사',
	'카플릭스',
	'자동차거래소',
	'부산모터스',
	'스카이모터스',
	'주식회사 오토카인드',
	'그차는내차',
	'세진자동차매매상사',
	'안상현모터스',
	'스카라베 주식회사',
	'다비드 글로벌',
	'주식회사 모터웨이',
	'카카오토',
	'행운상사',
	'워너비카',
	'보석모터스',
	'엘앤씨랩',
	'신대신모터스',
	'금메달자동차매매상사',
	'중사모터스',
	'전국화물차매매센터',
	'봄모터스',
	'엔젤모터스',
	'윈모터스',
	'대구셀카중고차',
	'당근모터스',
	'대연 오토월드',
	'원모터스',
	'주식회사 하이마이카',
	'휴먼오토',
	'아이디모터스',
	'주식회사 다빈치오토',
	'가양자동차',
	'차마이카',
	'파프리카',
	'수덕모터스',
	'고모터스',
	'뉴오케이모터스',
	'소사벌자동차매매상사',
	'벤케이모터스',
	'광주중앙자동차',
	'케이제이모터스',
	'프로무역',
	'세양물류주식회사',
	'비엠자동차',
	'마이카4',
	'한백모터스',
	'성우중고차',
	'아이러브카',
	'차마당',
	'한비아모터스',
	'티케이(TK)모터스',
	'오썸아우토',
	'스마일자동차 레바토',
	'바른카',
	'원모터스',
	'케이오토컴퍼니주식회사',
	'(주)기억',
	'주식회사 달모터스',
	'오케이오토',
	'열무무역',
	'주식회사 정이모터스',
	'대한종합자동차상사',
	'시원모터스',
	'이조은모터스',
	'수원중고차 경기카',
	'친절한 모터스',
	'(주)카포인트',
	'나경상사',
	'대성모터스 주식회사',
	'(주)더카모터스',
	'세모카',
	'코오롱모빌리티그룹(주) 702Prime 장한평지점',
	'건모터스풍동',
	'세일모터스',
	'경인모터스',
	'우리모터스',
	'태성모터스',
	'에이원모터스 주식회사',
	'차톡',
	'정직모터스',
	'뉴부산모터스',
	'연제모터스',
	'타이거모터스',
	'월드상사',
	'뉴현대모터스',
	'유카오토',
	'카리브모터스',
	'케이나인 코퍼레이션',
	'강철',
	'가은모터스',
	'에스제이오토',
	'대구모터스',
	'뉴세븐자동차상사',
	'한마음모터스',
	'수모터스',
	'국민플러스',
	'카뱅모터스',
	'뉴드림카',
	'부일상사',
	'기웅모터스',
	'바른자동차 주식회사',
	'인천 보배중고차',
	'붕붕자동차',
	'방방모터스',
	'(주)새롬모터스',
	'애니오토모빌 주식회사',
	'국제자동차매매상사',
	'세븐모터스',
	'두손모터스2',
	'에이치엘홀딩스 주식회사',
	'아크모터스',
	'(주)모터풀',
	'몽스모빌레',
	'세화모터스',
	'지오모터스',
	'엄모터스',
	'젬카모터스',
	'동우자동차매매상사',
	'OK자동차매매상사',
	'(주)세종자동차',
	'은성무역',
	'주식회사 카다오토모빌',
	'TS모터스',
	'경동모터스',
	'(주)투두인터내셔널',
	'(주)호인모터스',
	'국민모터스',
	'금강트럭',
	'플러스자동차',
	'케이씨씨오토(주)',
	'세인모터스',
	'에이치에스효성 더클래스',
	'(주)엠모터스',
	'카발로(CAVALO)',
	'일등자동차',
	'주식회사 천사',
	'(주)하이엔드모터스',
	'서진오토',
	'필카',
	'타이거무역',
	'주식회사 한강상사',
	'경기자동차앤카앤톡',
	'은혜자동차',
	'설레임마이카',
	'주식회사 이들컴퍼니',
	'제이원오토',
	'픽카소',
	'제이모션',
	'지니모터스',
	'하이코르오토',
	'민모터스',
	'온누리모터스',
	'원주현수중고차',
	'가진모터스',
	'주식회사 제네럴모터스',
	'케이카 주식회사 김포지점',
	'팔팔판다중고차',
	'주식회사 로얄티',
	'원주자동차매매상사',
	'올댓차차',
	'에스케이 모터스',
	'주식회사 준모터스상사',
	'진모터스',
	'미래카월드',
	'더케이모터스',
	'하나모터스',
	'성실모터스',
	'드림디오토',
	'큐모터스',
	'케이1car',
	'카울렛',
	'호차모터스',
	'명랑모터스',
	'에덴자동차매매상사',
	'아라모터스',
	'붕붕모터스',
	'윤모터스 북구',
	'오토파크',
	'강륜모터스',
	'고고모터스',
	'코오롱모빌리티그룹(주)702prime 김포지점',
	'차주름',
	'에스제이자동차매매상사',
	'하렌카',
	'(주)준모터스',
	'카프로',
	'점보모터스',
	'브이아이피모터스',
	'이수오토',
	'뉴보석자동차',
	'주식회사 플로시모터스',
	'바로모터스',
	'온모터스',
	'주식회사 킹모터스',
	'서희모터스',
	'오토파트너스',
	'주식회사 메르디앙오토',
	'뉴MJ모터스',
	'예스카포유',
	'칸모터스',
	'마니카',
	'해승모터스',
	'진장모터스',
	'국민모터스',
	'조이카',
	'도야모터스',
	'포스카',
	'신우모터스',
	'다온모터스',
	'융 모터스',
	'브이아이피준모터스',
	'주식회사 브로엠제이',
	'주식회사 신강변모터스',
	'케이카 화성지점',
	'부릉부릉닷컴',
	'코리아자동차',
	'씨엔에프',
	'(주)오토핸즈',
	'유미카',
	'쏭카',
	'케이카 주식회사 경기서부지점',
	'울림모터스',
	'(주)대박모터스',
	'오토 플렉스(AUTO FLEX)',
	'케이카 주식회사 분당용인지점',
	'케이카 주식회사 강서지점',
	'케이카 주식회사 양산지점',
	'케이카 주식회사 서대구지점',
	'에스에이치모터스(임시)',
	'(주)두운카',
	'바이에른오토(주) 수원오토월드지점',
	'(주)만소리오토모빌리',
	'원주 제로모터스',
	'요요모터스',
	'코오롱모빌리티그룹(주)702Prime 장안평지점',
	'삼화무역',
	'마이카5',
	'지에스모터스',
	'주식회사 지지카',
	'(주)카머치',
	'오토브릿지',
	'(주)아이오토마스터',
	'엘리트모터스',
	'카 리더스 클럽',
	'코오롱모빌리티그룹(주)',
	'알모터스',
	'주식회사 엠케어모터스',
	'주식회사윤모터스',
	'보람중고자동차',
	'금성모터스',
	'조은자동차',
	'중고차랩 매매상사',
	'제이카',
	'바로모터컴퍼니 주식회사',
	'썬모터스',
	'(주)이엘모터스',
	'(주)백두대형매매상사',
	'벨맥스 모터스',
	'성광자동차매매상사',
	'카올모터스주식회사',
	'드림오토 매매상사',
	'골든모터스',
	'주식회사 오성트럭',
	'(주)뉴대부자동차',
	'성실모터스',
	'주식회사 아이작',
	'주식회사 에이지모터스',
	'비알모터스',
	'슬기로운 딜러생활',
	'주식회사 노바트레이딩',
	'안심모터스',
	'차카',
	'(주)사하모터스',
	'갤러리모터스',
	'오토필드모터스',
	'주식회사 오토스마일',
	'대한자동차매매상사',
	'주식회사 제시카',
	'(주)더원중고차',
	'알르와시트레이딩(ALRWASI TRADING)',
	'(주)강변모터스',
	'주식회사 설레임오토모티브',
	'주식회사 오토위드어스',
	'한스오토',
	'오토플레닛',
	'서대구중고차',
	'준모터스',
	'퍼스트다이렉트모터스 수원점',
	'(주)월드모터스',
	'주식회사 한성상사',
	'점보모빌리티 주식회사',
	'숨카 직영점',
	'주식회사정도자동차',
	'주식회사 하버브알바시오니',
	'키트카매매상사(주)',
	'동영자동차',
	'윤이자동차',
	'티에스오토',
	'정우5호점',
	'주식회사 캐낸다',
	'월드모터스',
	'차오름모터스',
	'케이모터스',
	'오토프라임',
	'제이씨오토',
	'신성모터스',
	'(주)에스씨오토',
	'달인',
	'온누리모터스',
	'이에스오토모빌',
	'로얄모터스',
	'선인모터스',
	'뉴월드모터스',
	'주식회사 블랙케이',
	'바른트럭상사',
	'세이프카',
	'백두자동차',
	'양주케이모터스',
	'M모터스',
	'윈씨에이치모터스',
	'스피드모터스',
	'주식회사 대구중고차하나카즈',
	'나이스카',
	'당근모터스',
	'카우자동차',
	'카보스',
	'카마트자동차 주식회사',
	'케이스타',
	'행복모터스',
	'베스트모터스',
	'주식회사 화이트웨이',
	'태금모터스',
	'강남모터스',
	'나무모터스',
	'더드림카',
	'동카',
	'(주)남안성폐차산업 용인지점',
	'주식회사 정성자동차',
	'(주)애니카모터스',
	'씽씽카',
	'양주중고차 에이원오토',
	'KM모터스',
	'하나오토',
	'신화모터스',
	'뉴스카이모터스',
	'파트너스 매매상사',
	'코오롱모터스(주)BPS대구지점',
	'주식회사 상진기업',
	'다원모터스',
	'(주)신세계자동차',
	'류크레이션',
	'mk모터스',
	'키다리상사',
	'월드모터',
	'(주)파인뱅크',
	'(유)카마트상사',
	'현모터스',
	'다산다모터스',
	'상원모터스',
	'건모터스',
	'주식회사 도밍고 무역',
	'(주)이카(ecar)',
	'카톡모터스',
	'케이카 주식회사 오산동탄지점',
	'미카',
	'세진모터스',
	'원스탑무역',
	'착한중고차',
	'정든모터스',
	'뉴럭키',
	'봉카딧컴',
	'백제모터스',
	'판다카2',
	'주식회사 위드카',
	'(주)오토플러스 리본카 일산지점',
	'(주)팔팔모터스',
	'대한모터스',
	'바른중고차',
	'차차상사',
	'대한자동차',
	'찬찬카',
	'신삼성자동차상사',
	'제일상사',
	'새마을모터스',
	'관악JD모터스',
	'주식회사 해피카',
	'조선 중고차',
	'김해중고차상사',
	'유림모터스',
	'지우모터스',
	'아제카',
	'뉴에스케이상사(주)',
	'(주)바이더카',
	'부산중고차매매상사',
	'뉴드림모터스',
	'UPGU CAR',
	'오뚜기자동차',
	'주식회사 더케이오토모티브',
	'현대월드 중고차',
	'주식회사 탑모터스',
	'서구모터스',
	'한빛모터스',
	'최강모터스',
	'아크모터스',
	'대영자동차',
	'탑딜중고차',
	'(주)더퍼스트카',
	'원오토모빌',
	'제이에스모터스',
	'정안모터스',
	'케이카 세종 경매장',
	'에쓰아이모터스',
	'(주)카인드카',
	'주식회사 바오모터스',
	'브라더오토모빌',
	'주식회사 형제모터스',
	'타보고모터스',
	'뉴현대모터스',
	'우정모터스',
	'브이모터스',
	'주식회사 인트로',
	'이지모터스',
	'카고고',
	'카즈모터스',
	'성수자동차상사',
	'주원모터스',
	'한마음모터스',
	'친절한모터스',
	'신영모터스',
	'윤모터스',
	'퍼스트모터스',
	'중고차갤러리',
	'스마일오토모빌',
	'백두자동차매매상사',
	'명진모터스',
	'코오롱모터스(주)BPS부산지점',
	'주식회사 카플러스',
	'대잠자동차매매상사',
	'J모터스',
	'굿모닝모터스',
	'태백상사',
	'(주)우성모터스',
	'(주)손오공 강서지점',
	'(주)디에이모터스',
	'뉴코리아모터스',
	'남덕모터스',
	'153네트워크',
	'탑오토모터스',
	'육일자동차상사',
	'경원오토컴퍼니',
	'주식회사 비바모터스',
	'태평양모터스',
	'(주)엠에스모터스',
	'프라임모터스',
	'골드스타',
	'코오롱모터스(주)BPS대전지점',
	'주식회사 제로카',
	'케이제이(KJ)모터스',
	'(주)엔에이치씨홀딩스',
	'주식회사 동아에스엠씨',
	'코오롱모빌리티그룹(주)702Prime 대구지점',
	'주식회사 픽플러스 개러지',
	'훈카',
	'주식회사 하나오토',
	'대한',
	'(주)모든카갤러리',
	'전차모터스주식회사',
	'대덕모터스',
	'주식회사 오토플래닛',
	'타타모터스',
	'베스트모터스',
	'주식회사 강성자동차',
	'에스케이원카',
	'주식회사 투제이모터웍스',
	'창원중고자동차매매상사',
	'차차오토모빌',
	'진오토모빌',
	'로드카21',
	'서울자동차매매상사',
	'무지개모터스',
	'헤이오토',
	'명품모터스',
	'제일모터스',
	'주식회사 하나오토컴퍼니',
	'앰뷸런스코리아(송광상사)',
	'(주)더오토프라임',
	'유너모터스 주식회사',
	'진심모터스',
	'동호자동차상사',
	'태성 모터스',
	'에스유(SU)모터스',
	'다인모터스',
	'(주)차차차자동차',
	'(주)셀링오토',
	'제이와이모터스',
	'드림모터스',
	'봄봄모터스',
	'주식회사 직트럭',
	'오토플러스 리본카 동대구지점',
	'위드카',
	'에이치디글로벌',
	'주식회사 코리카인터내셔널',
	'진모터스',
	'주식회사 대치모터스',
	'유니모터스',
	'(주)하입카즈',
	'(주)선비',
	'주식회사 임팩트오토',
	'오토진',
	'BF오토갤러리',
	'주식회사 믿음모터스',
	'제이모터스',
	'(주)카렉스코리아 김포지점',
	'(주)픽플러스',
	'주식회사 제이에이치플러스',
	'동원무역',
	'디케이모터스',
	'엠비에이글로벌모터스 주식회사',
	'비전모터스',
	'주식회사신카',
	'(주)나인모터스',
	'카맨모터스',
	'케이카주식회사 부산지점',
	'케이카 주식회사 대구지점',
	'제일자동차매매상사',
	'웨스턴무역',
	'에스케이렌터카 주식회사',
	'삐용카 매매상사',
	'(주)제이케이오토',
	'이들컴퍼니',
	'트리플렉스 주식회사',
	'양주중고차 타이거오토',
	'(주)인카오토',
	'(주)오토유레카',
	'(주)화영자동차상사',
	'대석상사',
	'이지모터스',
	'올카모터스',
	'청학Emotors',
	'새신평상사',
	'이차로컴퍼니',
	'바른모터스',
	'에스제이모터스',
	'주식회사 준코',
	'무한자동차매매상사',
	'다둥이차',
	'리치모터스',
	'오토빌리지(주)',
	'수성자동차',
	'이스트오토 주식회사',
	'주식회사 메가피제이',
	'온카',
	'신원자동차',
	'신아오토모빌',
	'(주)미르오토모빌',
	'(주)고속',
	'제주소낭모터스',
	'트라움모터스',
	'유레카',
	'(주)더드림카 동부산점(상품용)',
	'주식회사 빅보스모터스',
	'서울무역',
	'(주)디에이치모터스',
	'뉴정우모터스',
	'카아모터스',
	'망고카 주식회사',
	'NS무역',
	'(주)예인자동차',
	'주식회사 에이치엔케이글로벌',
	'코리아 모터스',
	'하리보모터스',
	'오성무역',
	'일산오토갤러리',
	'두송오토',
	'명인모터스',
	'코오롱오토모티브(주)',
	'(주)에스에스 모터스',
	'제로모터스',
	'위카모빌리티 주식회사(용인지점)',
	'초이무역',
	'(주)삼진자동차매매상사',
	'복코모터스',
	'솔카 트레이딩',
	'동우모터스',
	'넘버원모터스',
	'도이치모터스 주식회사 강서 프리미엄',
	'라인모터스',
	'(주)에이투지네트웍스',
	'(주)대원모터스',
	'푸름상사',
	'비전모터스',
	'(주)삼일모터스',
	'(주)모터원',
	'건우모터스',
	'제이지(JG)모터스',
	'미다스',
	'올카모터스',
	'특장차마켓 매매상사',
	'카메이트',
	'채움모터스',
	'가바모터스',
	'다다오토',
	'에스지모터스',
	'케이카 주식회사 대구반야월지점',
	'동신자동차상사',
	'제이케이모터스',
	'전국자동차매매상사',
	'착한자동차',
	'차파는오빠',
	'와이티(YT)모터스',
	'심모터스',
	'(주)대성모터스',
	'스타자동차(주)',
	'행복중고차',
	'부산자동차매매상사',
	'(주)리더카',
	'주식회사 디에스오토',
	'프라임모터스',
	'혜성모터스',
	'(주)두바이카',
	'로얄모터스',
	'(주)태안 태안모터스 중고차사업부',
	'대한자동차',
	'(주)활화산모터스',
	'창영자동차매매상사',
	'태화모터스',
	'서청주매매상사',
	'해성모터스',
	'희망드림자동차',
	'주식회사비나인',
	'케이씨 트레이딩',
	'패밀리모터스',
	'친절한피터팬',
	'픽플러스카',
	'하이모터스',
	'더선오토모빌',
	'원모터스',
	'한길모터스',
	'(주)이레카오토모티브',
	'빅히트모터스',
	'카마켓',
	'드림중고차',
	'진모터스',
	'(주)뉴카카',
	'모터스밸리 (주)',
	'(주)뉴신대모터스',
	'(주)신세계모터스',
	'메인모터스4',
	'위카모빌리티 주식회사 (부산지점)',
	'ALLCAR모터스',
	'수입차 비싼',
	'이스트카상사',
	'(주)누리자동차',
	'제이에이치모터스',
	'(주)위본 중고차 사업부',
	'(주)오토정',
	'카몰',
	'(주)티엠씨모터스',
	'명카모터스',
	'주식회사 하이엔드중고사업부',
	'주식회사 더바른컴퍼니',
	'윤모터스',
	'케이카 주식회사 시흥지점',
	'(주)세종카',
	'삼성자동차',
	'지현모터스',
	'주식회사 울산엔',
	'강호자동차매매상사',
	'스카이서비스',
	'엘셔비니모터스(ELSHERBINY MOTORS)',
	'경영상사',
	'카인터내셔널',
	'조한모터스',
	'케이오토뱅크 부천지점3',
	'(주)하나로모터스',
	'1호 모터스',
	'(유)마이카',
	'탑라인모터스',
	'케이엠자동차 매매상사',
	'이솔모터스',
	'(주) 명성모터스',
	'이루AUTO',
	'SH모터스',
	'다원오토',
	'더황금모터스',
	'(주)태경모터스',
	'주식회사 바이브웍스',
	'천운모터스',
	'엘디모터스',
	'왕성자동차매매상사',
	'누리자동차',
	'주식회사 뉴케이스페이스',
	'수모터스',
	'수모터스',
	'에드카',
	'뉴트럭판매 주식회사',
	'세븐모터스',
	'쏘니모터스주식회사',
	'애플',
	'건강한 중고차',
	'준더모터스',
	'케이아이모터스(주)',
	'브이아이피모터스',
	'붕붕모터스',
	'골드모터스',
	'(주)더뉴한솔',
	'스피드모터스',
	'판다카',
	'다다컴퍼니',
	'아라모터스',
	'정직한자동차',
	'에이스모터스',
	'주식회사 스마트자동차',
	'만해자동차 매매상사',
	'제일조은자동차',
	'승리자동차모터스(중고차매매상사)',
	'투투중고차',
	'주식회사 엘비모터스',
	'주식회사 스마트자동차',
	'레드모터스',
	'마니카',
	'오에스모터스주식회사',
	'대박모터스',
	'금호자동차상사',
	'드림모터스',
	'(주)카트랜드',
	'더마니카 동부산점',
	'K2모터스',
	'미남자동차',
	'에스에이치 모터스',
	'더클래스오토',
	'JK모터스',
	'남부자동차매매상사',
	'더드림무역',
	'라온모터스',
	'한결모터스',
	'차파는최부장',
	'(주)행복드림카',
	'주식회사 에스유카',
	'지니어스BAY',
	'제일모터스',
	'(주)퀘파사 다스오토',
	'태양모터스',
	'에스원 모텨스',
	'(주)탑모터스',
	'현성모터스',
	'오토플러스(주) 대구',
	'서원글로벌',
	'동원모터스',
	'주식회사 아시아모터스',
	'남안성트럭매매상사',
	'로다오토모빌',
	'에이스모터스',
	'삼영모터스 주식회사',
	'세원모터스',
	'주식회사 큐브웍스',
	'(주)한길유씨에스',
	'해원상사',
	'재경모터스',
	'제이카(JCAR)',
	'케이카 해운대지점',
	'케이카 구미지점',
	'케이카일산지점',
	'케이카화곡지점',
	'당근카',
	'에스에이치모터스',
	'유화자동차 주식회사',
	'유카로오토모빌(주)중고차사업부',
	'(주)한울모터스',
	'영광자동차 매매상사',
	'아이모터스',
	'키트카',
	'(주)투에이치컴퍼니',
	'이준카',
	'주식회사 엠투스페이스',
	'극동모터스',
	'주식회사 뉴대한모터스',
	'태경모터스',
	'보광모터스',
	'로고스모터스',
	'은아모터스',
	'그랜드상사',
	'에이치모터스',
	'금산모터스',
	'효성상사',
	'(주) 중사모터스오토월드점',
	'(주)무룡인더스',
	'주식회사 이엑스오토',
	'봉자동차',
	'(주)신박한자동차',
	'제이모터스',
	'스마일 중고차 상사',
	'오토카',
	'성원모터스',
	'홍모터스',
	'조은모터스',
	'에이치브로 모터스',
	'누리모터스',
	'카넷',
	'베리카',
	'주식회사 케이비씨모터스',
	'(주)정진엠티에스',
	'신드롬모터스',
	'(주)카마트몰',
	'땡큐모터스',
	'현대글로비스 주식회사',
	'(주)하이모터스',
	'블루모터스',
	'정모터스',
	'오성모터스',
	'창진모터스',
	'(주)도전',
	'제논모터스',
	'중원모터스',
	'현대자동차 매매상사',
	'에쓰오토매매상사',
	'주식회사 인증모터스',
	'(주)바른차',
	'제이제이 모터스',
	'(주)장안오토랜드',
	'제이엠모터스',
	'원카',
	'뉴마도모터스',
	'유레카',
	'주식회사 알차이노베이션',
	'우진모터스',
	'주식회사 팀모터스',
	'화이트모터스',
	'신세계모터스',
	'주식회사 글로리모빌리티',
	'주식회사 프리오토',
	'주식회사 대운모터스',
	'(주)해성모터스',
	'지엔지통상',
	'고고카',
	'스마일자동차',
	'미미카',
	'착한모터스',
	'(주)리드옥션',
	'주식회사 안산상사',
	'더베스트자동차',
	'(주)동인모터스',
	'(주)엠월드',
	'굿모터스',
	'이삭모터스2호점',
	'주식회사 오토컴퍼니',
	'넘버원모터스',
	'(주)아이언오토',
	'루비노',
	'(주)숨카',
	'신진모터스',
	'모토모토',
	'어벤져스모터스',
	'(주)제이디모터스',
	'The Best 모터스',
	'인생내차 매매상사',
	'에이치케이(HK)중고차 수출무역',
	'나무',
	'얄개자동차',
	'서해모터스',
	'에이치모터스',
	'우현모터스',
	'(주)프라임글로벌',
	'케이엠모터스',
	'주식회사 디엘모터스',
	'레인보우',
	'(주)명진모터스',
	'중고차에이팀',
	'카온누리',
	'오토피아',
	'(주)현대상사',
	'(주)엘리트모터스',
	'(주)오케이모터스',
	'오토앤리스',
	'우정상사',
	'별모터스',
	'주식회사 오토네이션',
	'새봄모터스',
	'기분좋은자동차',
	'주식회사 성진모터스',
	'더좋은카',
	'주식회사 레이브',
	'화신모터스',
	'에이스모터스',
	'JC모터스',
	'카원셀러',
	'(주)오토웨이',
	'케이에이치오토',
	'첨맘중고차',
	'주식회사 오토케이',
	'바른딜러',
	'유민모터스',
	'아이러브카',
	'수오토트레이딩',
	'시티모터스',
	'풍년자동차매매상사',
	'종현상사',
	'금호자동차매매상사',
	'차차모터스',
	'한국자동차상사',
	'(주)형제모터스',
	'제이씨모터스',
	'한국자동차',
	'팬더모터스',
	'(주)세기자동차',
	'나연모터스',
	'kb모터스',
	'케이카트레이딩',
	'(주)화성트럭',
	'주식회사 나린코리아인터내셔널',
	'드림모터스',
	'제이모터스',
	'대원모터스',
	'카매니아',
	'신세계모터스',
	'티에이치 모터스',
	'라온모터스',
	'월드브로스',
	'장군모터스',
	'(주)다온모터스',
	'하이모터스',
	'중앙자동차매매상사',
	'롯데매매상사',
	'아이엠모터스',
	'(주)셀렉트오토',
	'한강자동차',
	'SJ모터스',
	'현대자동차',
	'도이치모터스',
	'인증자동차(주)',
	'카존',
	'주식회사 에이엠씨인터내셔널',
	'다나자동차',
	'주식회사 뉴와이에스모터스',
	'주식회사 오토넷글로벌',
	'비케이모터스',
	'(주)케이탑모터스',
	'청년오토',
	'나이스모터스',
	'순무역',
	'범모터스',
	'(주)경기모터스',
	'멀티모터스',
	'95모터스',
	'트루아우토',
	'골드',
	'(주)중앙트럭',
	'요코트레이드',
	'평화상사',
	'퍼펙트카',
	'주식회사 와니파트너스',
	'도로오토모티브중고차사업부',
	'엔카닷컴(관리자용)',
	'위카',
	'다인코리아',
	'동남자동차매매상사',
	'골든모터스',
	'상화모터스',
	'조은자동차 주식회사',
	'주식회사 오톰',
	'토토자동차',
	'(주)더쿨모터스',
	'(주)으뜸자동차',
	'그랜드자동차상사',
	'엔케이모터스',
	'호야오토모빌',
	'JJ모터스',
	'에이스모터스',
	'한성자동차(주)',
	'주식회사 진흥무역코리아',
	'주식회사 다모아모터스',
	'정모터스',
	'에이스 모터스',
	'해성자동차상사',
	'살카팔카',
	'MK모터스',
	'뉴삼일모터스',
	'주식회사제이에스오토',
	'신세계모터스',
	'(주)한밭트럭',
	'(주)고르고 모터스',
	'(주)구루마',
	'kk자동차',
	'아셀모터스',
	'에스클래스',
	'태성모터스',
	'에스케이(SK)모터스',
	'드림카',
	'(주)겟차',
	'새안동자동차',
	'스타카',
	'제이카모터스',
	'쓰리노 모터스',
	'대구종합자동차상사',
	'아우토슈타트(주)북대구지점',
	'미소자동차상사',
	'착한모터스',
	'주식회사 금오모터스',
	'조은중고차',
	'(주)대진상사',
	'바이오토',
	'뉴윤모터스(주)',
	'제이에스트레이딩',
	'뉴에버모터스',
	'BB모터스',
	'(주) 비비드카',
	'사라트레이딩',
	'정모터스(주)',
	'준모터스',
	'케이에스모터스',
	'카뱅크모터스',
	'카펀',
	'와이비모터스',
	'(주)시몬카',
	'구구상사주식회사',
	'동진모터스',
	'밀성자동차매매상사',
	'(주)디에이모터스',
	'정모터스',
	'주식회사골드상사',
	'주식회사 김포오토파크',
	'주식회사 비엔케이 모터스',
	'오토레이코리아',
	'소망자동차',
	'대풍매매상사',
	'(주)좋은자동차',
	'JR모터스',
	'주식회사 로한컴퍼니',
	'다온자동차',
	'명성모터스',
	'(주)성인모터스',
	'늘무역',
	'기능장중고차(카투데이)',
	'빅모터스',
	'바론카',
	'뉴스타모터스',
	'성원모터스 3호',
	'제이디모터스',
	'유레카모터스',
	'신세계자동차매매상사',
	'월드모터스',
	'(주)해피모터스',
	'오토J',
	'(주)한경오토',
	'(주)스페셜원모터스',
	'TIDA(티다)',
	'에이제이오토',
	'(주)현대안심샵',
	'초심모터스',
	'제이모터스',
	'주식회사 그린모터스',
	'한성자동차 용인',
	'그랜드모터스 주식회사',
	'(주)오토하이',
	'씨에스엠(CSM) Auto Compa',
	'(주)아하에이전트',
	'(주)삼보특수차',
	'중고차프로',
	'신구자동차매매상사',
	'유진상사',
	'에스케이자동차매매상사',
	'튼튼모터스',
	'주식회사 올뉴카',
	'차를파는사람들',
	'오토파크',
	'(주)이볼브오토모빌',
	'주식회사 그레이316',
	'CAR유모터스',
	'디에이치모터스',
	'명차모터스',
	'탑모터스',
	'착한중고차매매상사',
	'태광모터스',
	'성화모터스',
	'신강변모터스',
	'주식회사 차순이모터스',
	'한솔무역',
	'(주)라온자동차',
	'동승모터스',
	'최고자동차',
	'세종모터스',
	'(주)명성자동차월드',
	'동산자동차',
	'(주)알차',
	'벧엘자동차2',
	'오산중고차매매상사',
	'(주)오토파트너',
	'메인모터스2',
	'유일모터스',
	'서로모터스',
	'세븐모터스',
	'우리모터스',
	'굿카모터스',
	'푸른상사 (주)',
	'미소모터스 매매상사',
	'삼성트레이딩',
	'주식회사 케이씨트레이드',
	'믿음모터스',
	'세왕모터스',
	'대경모터스',
	'신세계자동차매매상사(주)',
	'주식회사 엘케이모터스 매매상사',
	'얄개모터스',
	'달구지',
	'인하 모터스',
	'한결모터스',
	'에스케이(SK)헤이카',
	'한세무역',
	'세컨무역',
	'(주)오영모터스',
	'(주)잘가라잘카',
	'원자동차매매상사',
	'삼우자동차',
	'의정부중고차 티원모터스',
	'용인중고차매매상사',
	'내장산자동차매매상사',
	'중고차바보',
	'마린모터스',
	'성지무역',
	'알뜰중고차',
	'제주K모터스',
	'(주)스마트모터스',
	'세진모터스',
	'( 주 )샵5모터스 (상품용)',
	'원모터스',
	'바른모터스',
	'(주)현카',
	'진모터스',
	'청년모터스',
	'(주)솔카',
	'태양상사',
	'(주)카모아모터스',
	'에스엠(SM)모터스',
	'트러스트오토모빌',
	'(주)착한오토',
	'주식회사 프라임모터스',
	'(주)리원',
	'에이원오토',
	'제이모터스',
	'(주)스타오토넷',
	'주식회사 영모터스',
	'주식회사 일프로',
	'신한모터스',
	'(유)기운모터스',
	'(주)씨에스모터스',
	'오성모터스',
	'메카모터스(주)',
	'현모터스',
	'케이모터스',
	'준모터스',
	'UN상사',
	'K무역',
	'(주)카매니저',
	'한우카',
	'남부산모터스',
	'이유모터스',
	'(주)이룸모터스',
	'동양상사',
	'퍼스트카',
	'건영모터스',
	'(주)오토씨티',
	'승아무역',
	'153모터스',
	'동아에이알시(주)',
	'합동상사',
	'세원모터스',
	'제이원오토',
	'토이모터스',
	'윤모터스',
	'대구중고차',
	'라온모터스',
	'오토플러스(주)',
	'오투모터스',
	'정원모터스',
	'주식회사 홈카',
	'밥자낫트레이딩',
	'프라임글로벌',
	'(주)스핀모터스',
	'AK모터스',
	'(주)필카',
	'믿음자동차매매상사',
	'오카',
	'윈윈모터스',
	'태양모터스',
	'정카',
	'(주)시온자동차',
	'(주)대디모터스',
	'사과나무자동차',
	'(주)한마음트럭',
	'행운모터스',
	'엠피크',
	'(주)바바리안모터스 비피에스',
	'알차',
	'주식회사 더나은자동차',
	'럭키모터스',
	'(주)더153',
	'뉴세종모터스',
	'아이앤지 글로벌',
	'주식회사 오토플랜(Auto Plan',
	'전주자동차매매상사',
	'경동자동차',
	'윤s모터스',
	'마이오토링크(주)중고차사업부',
	'주식회사 대한상사 트럭',
	'동원모터스상사',
	'킹스무역',
	'(주)영업왕자',
	'태성모터스',
	'에이스모터스',
	'카몽',
	'(주)수정오토',
	'그린모터스',
	'데일리모터스',
	'히트모터스',
	'우주모터스',
	'(주)플레이카',
	'로얄모터스',
	'YB무역',
	'주식회사 누리카파크',
	'주식회사 모던카',
	'썬모터스',
	'삼일모터스',
	'대구오토 모터스',
	'메이저모터스',
	'에이치(H)모터스',
	'킹카',
	'SM모터스',
	'메인모터스',
	'창원중고차 KC 조일모터스',
	'사랑모터스',
	'성원모터스',
	'엠지모터스',
	'플랜모터스',
	'바름모터스',
	'BB모터스',
	'주식회사 이레모터스',
	'마인드카',
	'골드모터스',
	'(주)V모터스',
	'대동자동차매매상사',
	'현우카',
	'제이엠 오토모빌',
	'A모터스',
	'슈퍼모터스',
	'미소중고차',
	'드림모터스',
	'굿차',
	'차차차모터스',
	'드림모터스',
	'바른모터스',
	'태진모터스',
	'세종트럭',
	'오토플랜',
	'스카이모터스',
	'라온무역',
	'(주)우리집자동차',
	'나이스무역',
	'프로모터스',
	'주식회사 박차컴퍼니',
	'주식회사 프랜즈모빌리티',
	'(주)카르메스오토',
	'굿홀딩스',
	'한솔자동차매매상사',
	'나라자동차',
	'하나무역',
	'부산모터스',
	'호호 모터스',
	'행운모터스',
	'일등모터스',
	'이(e)모터스',
	'주식회사참사랑상사',
	'뉴구마자동차매매상사',
	'(주)차클릭',
	'(주)수한모터스',
	'엠모터스',
	'(주)신화모터스',
	'(주)제이와이모터스',
	'서북인터내셔널(주)',
	'JS모터스',
	'주)에이비카스',
	'주식회사 오토룩2',
	'진모터스',
	'신용모터스',
	'아이러브카 자동차매매센터',
	'주식회사 조은모터스',
	'(주)제일모터스',
	'모터라인',
	'형제상사',
	'트윈무역',
	'제일무역',
	'남수원모터스',
	'스타모터스',
	'오토마트',
	'산모터스',
	'다온모터스',
	'(주)차조아네트웍스',
	'(주)안흥자동차',
	'마이오토링크(주)',
	'마루자동차매매상사',
	'위즈오토모티브',
	'준오토글로벌',
	'뉴부싼카',
	'탱크모터스',
	'주식회사 비전모터스',
	'주식회사 애니카트레이딩',
	'에이치원오토주식회사',
	'(주) 경일모터스',
	'ALKARAK TRADING COMP',
	'시은상사',
	'오복상사',
	'주식회사산다모터스',
	'차파는김씨',
	'태풍자동차',
	'동양모터스',
	'(주) 콰트로',
	'(주)로또자동차',
	'동양자동차매매상사',
	'송도무역',
	'카네이션 무역',
	'영남플러스모터스',
	'드림모터스',
	'주식회사에코카',
	'타타타',
	'인정모터스',
	'(주)라희모터스',
	'부경모터스',
	'미래자동차',
	'오토메이트',
	'정우2호점',
	'(주)에스비자동차',
	'수원모터스',
	'다온',
	'(주)고물상',
	'케이지모빌리티 주식회사 인증중고차',
	'윤트레이딩',
	'신한모터스',
	'씨와이모터스',
	'다인모터스',
	'정안상사',
	'메디엔인터내셔날',
	'태양오토 주식회사',
	'(주)엘림자동차',
	'프라임모터스',
	'(주)청담모터스',
	'삼성자동차매매상사',
	'주식회사 에스베네핏',
	'케이지무역',
	'대일모터스',
	'신도청모터스',
	'153모터스',
	'아이원카',
	'주식회사 누비다모터스',
	'차모터스',
	'케이비모터스',
	'유한회사 스카이',
	'세이프중고차(주)',
	'행복자동차매매상사',
	'주식회사 오토스토리',
	'하랑모터스',
	'마이카모터스',
	'케이탑',
	'위드모터스',
	'헌스트레이딩',
	'대진모터스',
	'코리아모터스',
	'(주)굿트럭',
	'제이모터스',
	'착한중고차',
	'(주)가리온모터스',
	'주식회사 경보모터스',
	'힘찬모터스',
	'곤모터스',
	'(주)제츠',
	'코오롱모빌리티그룹(주)',
	'드림모터스',
	'윤프로모터스',
	'삼원모터스',
	'주식회사 퍼스트다이렉트모터스',
	'(주)차파는사람들',
	'다이나아우토',
	'(주)스타필드',
	'다온모터스',
	'엠플러스',
	'카머니대부주식회사',
	'KB모터스',
	'뉴수성자동차',
	'대운자동차상사',
	'판다카',
	'에스오토',
	'다카자동차',
	'(주)성공 모터스',
	'엠에스모터스',
	'에이스모터스',
	'(주)지호모터스',
	'무한모터스',
	'디에스오토 주식회사',
	'주식회사 카와라',
	'해동상사',
	'제이지모터스',
	'부릉모터스',
	'비에스모터스',
	'(주)을지자동차상사',
	'주식회사 예일자동차',
	'고릴라모터스',
	'승진자동차매매',
	'나경모터스',
	'신안동EV친환경모터스주식회사',
	'(주)서울모터스',
	'에이에이모터스',
	'바바리안모터스 고양',
	'대경자동차매매상사',
	'영제오토월드',
	'케이모터스',
	'국제자동차',
	'SH모터스',
	'주식회사 로이오토',
	'오토피아',
	'(주)네바퀴',
	'주식회사디케이무역',
	'아이오토',
	'(주)더이룸카',
	'윤모터스',
	'엔에스NS모터스',
	'(주)예스카',
	'서울오토갤러리 도이치모터스',
	'갑부상사',
	'길상모터스 매매상사',
	'에스엘모터스',
	'아주자동차',
	'M3모터스',
	'주식회사 아이오토스',
	'헬로모터스',
	'준파크',
	'우덕모터스',
	'우송모터스',
	'모터스트리주식회사',
	'주식회사 라인오토',
	'광카',
	'대덕자동차',
	'종규네중고차',
	'행운모터스',
	'중고차브라더스',
	'정원모터스',
	'일등모터스',
	'(주) 수호모터스',
	'국민모터스',
	'중원모터스',
	'(주)넥스트오토',
	'카엔카무역',
	'세븐',
	'(주)나우모터스',
	'지카',
	'친절한중고차',
	'세영모빌리티(주)',
	'한결모터스',
	'카플릭스2',
	'주식회사디오카',
	'힘찬자동차',
	'(주)안모터스',
	'혜성자동차',
	'(주)아주트레이드',
	'주식회사 더굿카',
	'오토스마일',
	'세종오토',
	'비앤엘플러스일산지점',
	'화풍정모터스',
	'브라더모터스',
	'주식회사 더마니카',
	'대영모터스',
	'(주)이지코리아',
	'신수원자동차',
	'점보모터스',
	'서울오토벨',
	'SV모터스',
	'해성모터스',
	'(주)달인중고차',
	'주식회사 하이오토코리아',
	'명진상사',
	'HM오토모티브',
	'주식회사 제이제이 모터스',
	'월드무역',
	'주식회사 에스지엘',
	'주식회사서희디오토',
	'더존무역',
	'무릉상사',
	'진성모터스',
	'풀카',
	'(주)카포유',
	'제주셀카',
	'주식회사 제이모터스(J motors)',
	'다온무역',
	'대구트럭매매상사',
	'주식회사 에스비즈',
	'바오모터스',
	'(주)에이플러스모터스',
	'케이비모터스',
	'유주오토',
	'신부경모터스',
	'좋은차닷컴',
	'신성모터스',
	'케이모터스',
	'(주)가온자동차',
	'(주)아이에스오토모빌',
	'소원모터스',
	'드림모터스',
	'IK무역(아이케이무역)',
	'인연모터스',
	'(주)카피아',
	'주식회사 가도모터스',
	'주식회사 삼일상사',
	'유한회사 카카오토샵',
	'주식회사 케이비국민차',
	'(주)차모터스',
	'대건자동차',
	'(주)에이원모터스',
	'차사인모터스',
	'중고차마트',
	'주식회사 프렌즈카',
	'주식회사 모터살롱',
	'서원모터스',
	'탑모터스',
	'알차상사',
	'제이더블유',
	'주식회사 에스에이치모터스',
	'(주)브이아이피카',
	'카플래닛',
	'행운중고자동차상사',
	'메인모터스',
	'주식회사 올카',
	'바바리안모터스 BMW 인증중고사업부',
	'주식회사 더원모빌',
	'주식회사 오토엠',
	'오토라인',
	'(주)뉴하모니카',
	'올카 동부산점',
	'이수모터스',
	'비엠(BM)모터스',
	'에이진무역',
	'한양자동차',
	'주식회사 리본자동차',
	'주식회사 피플모터스',
	'킹모터스',
	'(주) 유카',
	'(주)하이브모터스',
	'오토윈스',
	'주식회사 차근모터스',
	'카픽',
	'뉴소나무상사',
	'(주)하이브모터스',
	'아인모터스',
	'월드모터스',
	'클린오토',
	'정인모터스',
	'(주)에이아이카',
	'엘메살라미',
	'탑초이스카',
	'싸이맥스',
	'지오모터스',
	'착한중고차2',
	'주식회사 에스케이엠엔터프라이즈',
	'오토월드',
	'에스원모터스',
	'(주)마이원카',
	'주식회사 이삭모터스',
	'(주)라인자동차',
	'(주)티에스모터스',
	'주식회사 아이러브카',
	'강서 주식회사 양심중고차김진',
	'주식회사 씨엠프라자',
	'주식회사 애플카',
	'신명성모터스',
	'케이카 주식회사 청주지점',
	'주식회사 아이엠모터그룹',
	'(주)유레카',
	'유진무역',
	'그린모터스',
	'다올자동차매매상사',
	'친구모터스',
	'(주)오토베이',
	'오토노바',
	'명진모터스',
	'태경모터스',
	'주식회사 뉴신원자동차',
	'신국제상사',
	'빛나는자동차',
	'(주)유진자동차판매상사',
	'유진자동차 매매상사',
	'비비(BB)모터스',
	'(주)진성사',
	'광덕모터스',
	'금평자동차매매상사',
	'내차어때',
	'주식회사 아시아오토',
	'황금모터스',
	'(주)마이카오토',
	'경기모터스',
	'용인터내셔널',
	'카맨모터스2호점',
	'신성모터스',
	'(주)청구모터스',
	'주식회사 한요',
	'주식회사 라임모터스',
	'주식회사 오토코디',
	'명광상사',
	'엔에이모터스',
	'스타모터스',
	'도담자동차',
	'주식회사 올바른자동차',
	'믿음모터스 주식회사',
	'엘모터스',
	'(주)고려자동차',
	'시원모터스',
	'153모터스',
	'진성자동차',
	'극동자동차상사',
	'주식회사 이든자동차',
	'(주)이조은모터스',
	'이십일세기모터스',
	'JC트레이딩',
	'(주)승학모터스',
	'엘케이모터스',
	'카모아',
	'미르모터스',
	'알차',
	'제이p 트레이딩',
	'(주)차앤문 모터스',
	'주식회사 오토리안',
	'카플러스',
	'에스비모터스',
	'(주)올뉴모터스',
	'장모터스',
	'(주)서진모터스',
	'케이오토트레이더스',
	'굿맨굿카',
	'글로리무역',
	'(주)원모터스',
	'자마이카',
	'수원해동자동차',
	'세진자동차매매상사',
	'주식회사 더카네트웍스',
	'MS모터스',
	'신대신자동차상사',
	'드림모터스',
	'황제모터스',
	'한빛모터스',
	'가도모터스',
	'골드문 모터스',
	'우정상사',
	'(주)하나오토',
	'스마일모터스',
	'주식회사 하이엔드모터스',
	'선진자동차(주)(상품용)',
	'엔와이무역',
	'주식회사 카스토어',
	'엠브이(MV)모터스',
	'금성자동차',
	'주식회사 바른모터스',
	'진명자동차',
	'아이원모터스',
	'(주)차랑차랑',
	'(주)네바퀴',
	'국민종합자동차상사',
	'토리무역',
	'가온오토',
	'한솔상사',
	'주식회사 브로엠에스',
	'(주)대원모터스',
	'우진상사',
	'(주)에이비씨모터스',
	'다온모터스',
	'주식회사 하나카모터스',
	'주식회사 베스트카',
	'더 좋은차',
	'카마트',
	'혁신 트레이딩',
	'KS무역',
	'주식회사 유로모터스',
	'태성모터스',
	'세븐카',
	'(주)쿨모터스',
	'쏭카',
	'에스제이(SJ)무역',
	'서린모터스',
	'주식회사 타요',
	'다모아모터스',
	'형카',
	'에스비(SB)모터스',
	'슝슝모터스',
	'동서자동차',
	'(주)예스오토',
	'준car',
	'(주)더골드모터스',
	'천마상사',
	'정우자동차상사',
	'나위사자드 주식회사',
	'드림모터스',
	'주식회사 일공공일카부카',
	'숨차',
	'The중고차',
	'대구중고차태형',
	'주식회사 에스에이치트레이딩',
	'주식회사 다올오토',
	'(주)예스모터스',
	'후후 Trade',
	'(주) 케이앤드에스모터스',
	'(주)새롬모터스',
	'현우자동차',
	'도성모터스',
	'주식회사 에이치알모터스',
	'아차차',
	'김도현모터스',
	'주식회사 에스알카',
	'에이비씨오토',
	'(주)대상모터스',
	'(주)비비드카',
	'설레임 오토모티브',
	'와이엠(YM)모터스',
	'주식회사 케이원인터내셔널',
	'신명가모터스',
	'해피온카',
	'(주)강남세종모터스',
	'울산N모터스',
	'차차차 모터스',
	'(주)오토핸즈 오토인사이드',
	'돼지카',
	'(주)유신모터스',
	'엔에이치카(NH Car)',
	'(주)오토앤오토',
	'뉴명가모터스',
	'주식회사 더하이엔드',
	'에스오토모빌',
	'에이스모터스',
	'에스다이렉트카',
	'(주)월드도이치오토모빌',
	'박준표 중고차',
	'그린자동차매매상사',
	'명가모터스',
	'엔젤카무역',
	'클라쎄오토(주)중고차사업부',
	'명품모터스',
	'에이드(AID)무역',
	'유일상사',
	'주식회사 주안모터스',
	'한성자동차(주)',
	'(주)하나로홀딩스',
	'더케이모터스',
	'공은모터스',
	'중앙에이플러스(중앙A+)',
	'중고차브라더스',
	'주식회사 조은오토',
	'카피디',
	'주식회사 케이아우토',
	'주식회사 제이티피엠(JTPM inc)',
	'(주)더원오토',
	'주식회사 유씨에스오토',
	'두리오토',
	'주식회사 뉴신용자동차',
	'윤모터스',
	'오토랜드',
	'주식회사 에코모터스',
	'주식회사 천재모터스',
	'(주)우수상사',
	'(주)티티카',
	'베스트자동차매매상사',
	'주식회사 오토멤버스',
	'주식회사 대기자동차',
	'케이카 주식회사 김포공항지점',
	'윈모터스 주식회사',
	'(주)트리에이치오토',
	'네바퀴사랑',
	'(주)하이오토',
	'주식회사 프로모터스',
	'(주)에스에스카',
	'톡카(Talk Car)',
	'주식회사 설레아',
	'(주)뉴카뱅크',
	'주식회사 태양모터스',
	'드림카',
	'(주)좋은차',
	'(주)자동차친구',
	'주식회사 153모터스',
	'(주)카옥션',
	'케이카 주식회사',
	'주식회사 모모 모빌리티',
	'(주)페어플레이유니버스',
	'주식회사 디오카',
	'케이카 주식회사 오산경매장',
	'(주)스마트카',
	'(주)소망자동차',
	'주식회사 케이엠모터스',
	'제이더블유 인터내셔널',
	'주식회사 케이제이모터스',
	'프로모터스',
	'케이카 주식회사 영등포지점',
	'주식회사 차탐',
	'애니원모터스',
	'뉴에이스',
	'(주)퍼스트모터스',
	'동행모터스',
	'차투차 주식회사',
	'선진모터스',
	'(주)영진모터스',
	'미래자동차매매상사',
	'주식회사 정모터스',
	'원민모터스',
	'비비(BB) MOTORS',
	'주식회사 씨티자동차매매상사',
	'브로드카',
	'(주)무한모터스',
	'퍼스트다이렉트중고차 안산점',
	'차다운 차',
	'온드림모터스',
	'엘리트모터스',
	'찐모터스',
	'주식회사 행차',
	'(주)오토피아',
	'주식회사 서현',
	'다올모터스',
	'세계자동차',
	'원(WON)모터스',
	'(주)이지오토',
	'(주)삼삼공모터스',
	'베델모터스',
	'(주)오토크루',
	'의정부금오상사',
	'제이에스(JS)모터스',
	'제이에스모터스',
	'(주) 세일카',
	'모토모토',
	'다온모터스',
	'주식회사 예스카',
	'현용모터스',
	'카포인트',
	'주식회사 카멘토모터스',
	'천안모터스 매매상사',
	'창대모터스',
	'제이에스자동차',
	'위드카',
	'(주)원탑모터스',
	'우리모터스',
	'오토리카',
	'싸다니카',
	'선한모터스',
	'주식회사 새임',
	'주식회사 버디카',
	'린모터스',
	'(주)다인모터스',
	'에스케이(SK)모터스',
	'원모터스(ONE모터스)',
	'주식회사 씨티자동차매매상사',
	'삭제필요',
	'피닉스모터스(주)',
	'주식회사 퍼스트오토',
	'(주)클래식오토',
	'차파는사람들',
	'으뜸상사',
	'유일오토',
	'에이블모터스',
	'서진모터스 주식회사',
	'주식회사 비케이모터스',
	'부부모터스',
	'마이카2',
	'스카이모터스',
	'주식회사 제이스모터스',
	'(주)영모터스',
	'주식회사 필컴퍼니',
	'코리아모터스',
	'좋은자동차',
	'울트라모터스',
	'신세계 자동차',
	'(주)브로모터스',
	'나래모터스',
	'꿈차',
	'(주)에스원모터스',
	'주식회사 삼일',
	'시아오토',
	'주식회사 케이엠모터스',
	'주식회사 해피카',
	'한국자동차',
	'하나모터스',
	'코렉트 천안',
	'(주)케이원카',
	'차왕모터스',
	'월드오토 주식회사',
	'주식회사 왓카(WHAT CAR)',
	'에스티오토',
	'신세계자동차매매상사',
	'신성유씨에스(주)',
	'(주)수모터스',
	'디케이(DK)모터스',
	'주식회사 다온모터스',
	'넘버원모터스(NO.1)',
	'기쁜중고차',
	'구구모터스주식회사',
	'천사모터스',
	'(주)이현모터스',
	'(주)더챔',
	'신한앤쌍용자동차 주식회사',
	'주식회사에스유즈드카',
	'슈퍼맨모터스',
	'주식회사 비케이투모터스',
	'(주)대신모터스',
	'(주)마이마이카',
	'(주)더오토',
	'누리모터스',
	'워너비모터스',
	'주식회사 몰타',
	'이안모터스',
	'대청모터스',
	'나이스 모터스',
	'M-모터스',
	'국보자동차매매상사',
	'대전1번중고차오토월드(주)',
	'(주)아이비코리아모터스',
	'주식회사 진이오토',
	'케이카 주식회사 이천지점',
	'퍼스트카',
	'티키타카',
	'형채와 자동차(주)',
	'주식회사 강서모터스매매',
	'카스토어',
	'주식회사 뉴행복드림카',
	'(주)더굿모닝자동차',
	'SK모터스',
	'(주)준모터스',
	'수성오토 마켓',
	'서해모터스',
	'주식회사 바른모터스',
	'킹카',
	'주식회사 카맨',
	'금평자동차상사',
	'롯데렌탈(주)',
	'태양오토모빌 주식회사',
	'케이카 주식회사 고양지점',
	'카마존',
	'(주)모든자동차',
	'부타무역',
	'주식회사 나라인터내셔널',
	'케이에스자동차',
	'주식회사 더킹모터스',
	'대일자동차',
	'부산중고차(주)',
	'(주) 아이오카',
	'영모터스',
	'세인모터스',
	'다스오토',
	'모빌팡',
	'(주)에이스타모터스',
	'퍼펙트카',
	'(주)카랜드',
	'믿음모터스',
	'(주)윤카',
	'룩카',
	'주식회사 케이비상사',
	'진성모터스',
	'덕신모터스',
	'뉴에덴상사',
];

export const CLEANDEALER_REQUEST_STATUS = {
	TARGET_SELECTED: 'TARGET_SELECTED',
	APPLICATION: 'APPLICATION',
	WAITING_DEPOSIT: 'WAITING_DEPOSIT',
	APPROVE: 'APPROVE',
	UNDER_CONDITION: 'UNDER_CONDITION',
	TERMINATION: 'TERMINATION',
};

export const COMPULSORY_IMG_ORDER = {
	VEHICLE_FRONT: 1,
	VEHICLE_REAR: 2,
	VEHICLE_LEFT: 3,
	VEHICLE_RIGHT: 4,
	VEHICLE_CENTER_FASCIA: 5,
	VEHICLE_DASHBOARD: 6,
};

export const EXPOSE_DESCRIPTION_NAMES = ['DIFFERENT_ACCIDENT', 'ADDITIONAL_MAINTENANCE', 'ETC'];
// API Response Data
export const ESTIMATE_PROGRESS_STAT = {
	REGISTRATION: 'REGISTRATION', // 접수
	PICTURE_REQUEST: 'PICTURE_REQUEST', // 사진등록대기
	WAITING: 'WAITING', // 견적대기
	BIDDING: 'BIDDING', // 견적요청
	SENDING: 'SENDING', // 낙찰진행중
	FINISHED_WITHOUT_SUCCESS: 'FINISHED_WITHOUT_SUCCESS', // 낙찰기간만료
	DISQUALIFICATION: 'DISQUALIFICATION', // 낙찰조건미달
	AUCTION_RESTART: 'AUCTION_RESTART', // 재견적처리
	SUCCESS: 'SUCCESS', // 결과발송
	CANCEL: 'CANCEL', // 신청취소
};

// 상태에 따른 UI 렌더링 조건
export const AUCTION_PROGRESS = {
	WAIT: 'WAIT', // 견적대기
	REQUEST: 'REQUEST', // 견적요청
	BID_IN_PROGRESS: 'BID_IN_PROGRESS', // 낙찰 진행중
	DEAL: 'DEAL', // 거래 중
	SUCCESS_DEAL: 'SUCCESS_DEAL', // 거래 성사
	CANCEL_DEAL: 'CANCEL_DEAL', // 취소
};

export const DEAL_REDUCE_TYPE = {
	PLATING_STAMPING: '외판 수리 필요',
	RESTORE_WHEEL: '휠 스크래치',
	CHANGE_TIRE: '타이어 교체',
	DIFFERENT_ACCIDENT: '사고정보 다름',
	ADDITIONAL_MAINTENANCE: '기타사항',
	ETC: '기타사항',
};
